/* Bechose · ao adicionar ao carrinho abre a gaveta lateral no lugar da notificação do topo.
   Antes de abrir, busca o carrinho já com o item novo e avisa o tema (theme:cart:change):
   sem isso a gaveta abria com o carrinho antigo e só mostrava o produto na segunda abertura. */
(function () {
  document.addEventListener(
    'theme:cart:popdown',
    function (event) {
      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (!drawer) return;
      event.stopPropagation();

      function abrir() {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: true }));
      }

      var rota = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
      fetch(rota + '.js', { headers: { Accept: 'application/json' } })
        .then(function (resposta) { return resposta.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          abrir();
        })
        .catch(abrir);
    },
    true
  );
})();
